import { render, staticRenderFns } from "./webgl.vue?vue&type=template&id=3029e4d2&scoped=true&"
import script from "./webgl.vue?vue&type=script&lang=js&"
export * from "./webgl.vue?vue&type=script&lang=js&"
import style0 from "./webgl.vue?vue&type=style&index=0&id=3029e4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3029e4d2",
  null
  
)

export default component.exports